import { useQuery } from '@tanstack/react-query';
import { dayMs, hourMs } from 'components/date_time/time';
import { sdClient } from 'contexts/SDKClientContext';

export type UseNodeSettingsOptions = Readonly<{
    /**
     * If set, options will be narrowed to only options valid for that specific location.
     */
    locationId?: string;
    disabled?: boolean;
}>;

/**
 * Gets a list of all valid options for all node settings that require specific
 * values (i.e., enumerations).
 */
export function useNodeSettingsOptions({ locationId, disabled }: UseNodeSettingsOptions) {
    return useQuery({
        queryKey: ['get-node-settings-options', locationId],
        queryFn: () => sdClient.getNodeSettingOptions({ locationId }),
        gcTime: 7 * dayMs,
        staleTime: 6 * hourMs,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        enabled: !disabled,
    });
}
